export default __webpack_public_path__ + "static/media/accomm_img_9.fff7e456.JPG";